import styled from 'styled-components';
import { colors, MediaQuery, zIndexes } from '../../../theme/style-helpers';

export const ModalBoxStyle = {
  overlay: {
    backgroundColor: colors.BLACK + colors.OPACITY_70_ALPHA_HEX_SUFFIX,
    zIndex: zIndexes.MODAL,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    maxWidth: '90em',
    backgroundColor: colors.LIGHT_GREY,
    padding: '0px 0px 48px 0px',
    overflowY: 'auto',
    height: 'auto',
    maxHeight: '900px',
    '@media (max-width: 766px)': {
      backgroundColor: 'red',
    },
  },
};

export const ModalBody = styled.div`
    padding: 0px 48px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;

    ${MediaQuery.small`
    max-width: 648px;
    min-width: 520px;
    width: auto;
    height: unset;
    `}
`;

export const CloseContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 24px;

    img {
        cursor: pointer;
    }
`;

export const ModalTitlesContainer = styled.div`
    display: grid;
    grid-gap: 12px;
    padding-bottom: 24px;
`;

export const ModalTitle = styled.div`
    font-size: 24px;
    font-weight: 500;
    line-height: 31px;
    letter-spacing: 0em;
    text-align: center;

    ${MediaQuery.small`
        font-size: 28px;
        line-height: 36px;
    `};
`;

export const ModalSubTitle = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
`;

export const ModalChildren = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 24px;
    font-size: 1.5rem;
    text-align: center;
`;

export const ButtonsWrapper = styled.div`
      display: flex;
      flex-direction: row;
      justify-content: ${(props) => (props.unique ? 'center' : 'space-between')};
      width: 100%;
      margin-top: 24px;

      button {
          width: auto;
      }

      ${MediaQuery.xSmall`
        flex-direction: column;

        button {
            margin: 8px 0;
        }
      `}
`;
